
import Form, { GroupItem, Label, SimpleItem } from "devextreme-react/form";
import React, { forwardRef} from "react";
import { useSelector } from "react-redux";
import Icon from "../../components/Icon/icon";

import { getLocalized } from "../../redux/localization";
import { renderInformationItem } from "../productRequestPage/detail";
import { AdminCategories } from "./type";

const CategoryDetail = forwardRef<any, { data: AdminCategories }>(
    ({ data }, ref) => {
        const localize = useSelector(getLocalized);

        return <div>
            <Form
                ref={ref}
                key="id"
                labelLocation="left"
                formData={data}
                showColonAfterLabel={true}
            >
                <GroupItem colCount={2}>
                    <GroupItem>
                        <SimpleItem
                            dataField="Name"
                            label={{
                                text: localize.getString("name"),
                            }}
                            render={renderInformationItem}
                        />
                        <SimpleItem
                            dataField="Description"
                            label={{
                                text: localize.getString("description"),
                            }}
                            render={renderInformationItem}
                        />
                        <SimpleItem
                            dataField="Seo"
                            label={{
                                text: localize.getString("seo"),
                            }}
                            render={renderInformationItem}
                        />
                        <GroupItem colCount={1}>
                            <SimpleItem
                                dataField="Icon"
                                label={{
                                    text: localize.getString("icon"),
                                }}

                                render={(item: any) => {

                                    if (item.editorOptions.value !== null) {
                                        return <div>
                                            <Icon icon={data.Icon}></Icon>
                                            <span>{item.editorOptions.value}</span>

                                        </div>;
                                    } else {
                                        return <span>-</span>;
                                    }



                                }}

                            >
                                <Label text={data.Icon}></Label>

                            </SimpleItem>

                        </GroupItem>
                        <SimpleItem
                            dataField="Color"
                            label={{
                                text: localize.getString("color"),
                            }}
                            render={renderInformationItem}
                        >
                        </SimpleItem>
                        
                    </GroupItem>
                </GroupItem>
            </Form>

        </div >
    }
)

export default CategoryDetail;